












































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { client } from "@/api/request";
// 共通コンポーネント
import VToolbar from "../../common/components/VToolbar.vue";
import SelectOption from "@/common/ui/presenters/select-option";
// 見積テンプレート
import {
  EstimateTemplate,
  EstimateTemplateItem,
  getEstimateTemplate
  // saveEstimateTemplate
} from "@/api/estimate-templates-api";
// 見積書項目
import EstimateItem from "../components/EstimateItem.vue";
import EstimateHeader from "../components/EstimateHeader.vue";
// 見積書項目 データ
import Estimate from "@/usecases/orders/estimate";
import EstimateItemModel from "@/usecases/orders/estimate-item";
import EstimateService from "@/usecases/orders/estimate-service";
import EstimateApi from "../../../api/orders/estimate-api";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import {
  calculateExpenseCategory,
  ExpenseCategoryTotal
} from "@/orders/domain/models/expense-category";
import UnitApi from "../../../orders/api/unit-api";
import UnitOption from "../presenters/unit-option";

import ProfitRateModal from "@/components/ProfitRateModal.vue";
import { estimateRoundedFromProfitRate } from "@/models/estimate-from-profit-rate";

// 行操作
import MoveEvent from "../presenters/move-event";
import { ESTIMATE_ITEM_LEVEL, NUMBER_ROUND, TYPE_ROUND } from "@/preferences";
import ExpensesCategoryGraphReport from "@/ui/order/components/ExpensesCategoryGraphReport.vue";
import Decimal from "decimal.js";
import LoadingButton from "@/components/LoadingButton.vue";
const estimateApi = new EstimateApi(client);
const unitApi = new UnitApi(client);
const service = new EstimateService(estimateApi);

interface X {
  b: number;
}

@Component({
  methods: {
    TYPE_ROUND() {
      return TYPE_ROUND;
    },
    NUMBER_ROUND() {
      return NUMBER_ROUND;
    }
  },
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    LoadingButton,
    ExpensesCategoryGraphReport,
    VToolbar,
    EstimateItem,
    EstimateHeader,
    ProfitRateModal
  }
})
export default class EstimateTemplateEditPage extends Vue {
  @Prop({ required: true }) estimateTemplateId!: string;

  calcFromProfitRateModalOpen = false;
  calcInvoiceFromProfitRateModalOpen = false;

  estimate = new Estimate();
  projectOptions: SelectOption[] = [];
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  estimateTemplate: EstimateTemplate | null = null;
  isShowNoteColumn: boolean = true;
  // The Set includes the IDs of the estimate_row at the lowest level.
  // Saving like this is for the logic of reloading the checkbox state when dragging and dropping in the table
  estimateRowSelected: Set<string> = new Set();
  isCheckAllEstimateRow: boolean = false;
  expenseCategoriesSelected: ExpenseCategoryTotal[] = [];
  headerDefault: HeaderItem[] = [
    {
      name: "操作",
      subs: [],
      width: "3.5rem"
    },
    {
      name: "見積項目",
      subs: [
        { name: "大項目", width: "8vw" },
        { name: "中項目", width: "8vw" },
        { name: "小項目", width: "10vw" },
        { name: "経費カテゴリ", width: "8rem" },
        { name: "数量", width: "5rem" },
        { name: "単位", width: "5rem" },
        { name: "単価", width: "6rem" },
        { name: "見積金額", width: "6rem" },
        { name: "備考", width: "1fr" }
      ]
    },
    {
      name: "予算項目",
      subs: [
        { name: "発注単価", width: "6rem" },
        { name: "発注金額", width: "6rem" },
        { name: "利益額", width: "6rem" },
        { name: "利益率", width: "5rem" }
      ]
    }
  ];
  headerWithoutNoteColumn: HeaderItem[] = [
    {
      name: "操作",
      subs: [],
      width: "3.5rem"
    },
    {
      name: "見積項目",
      subs: [
        { name: "大項目", width: "8vw" },
        { name: "中項目", width: "8vw" },
        { name: "小項目", width: "10vw" },
        { name: "経費カテゴリ", width: "8rem" },
        { name: "数量", width: "1fr" },
        { name: "単位", width: "5rem" },
        { name: "単価", width: "1fr" },
        { name: "見積金額", width: "1fr" }
      ]
    },
    {
      name: "予算項目",
      subs: [
        { name: "発注単価", width: "1fr" },
        { name: "発注金額", width: "1fr" },
        { name: "利益額", width: "1fr" },
        { name: "利益率", width: "1fr" }
      ]
    }
  ];
  header: HeaderItem[] = this.headerDefault;
  styleGridColumn: string = this.getWidthsString(this.header);
  orderToEstimatedNumberRound: number = NUMBER_ROUND[1];
  orderToEstimatedTypeRound: string = TYPE_ROUND[0];
  estimatedToOrderNumberRound: number = NUMBER_ROUND[1];
  estimatedToOrderTypeRound: string = TYPE_ROUND[0];
  status = "";

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  get categoryDiscountIds(): string[] {
    return this.expenseCategoryOptions
      .filter(category => category.text === "値引き")
      .map(category => category.value);
  }

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  //ロード時の動作、変更の監視
  @Watch("estimateTemplateId", { immediate: true })
  onEstimateTemplateChanged(estimateTemplateId: string) {
    this.initEstimateTemplate(estimateTemplateId);
  }

  protected async created() {
    await this.initUnitList();
    await this.initExpenseCategories();
    this.setCategoryDiscountIds();
    await this.initEstimateTemplate(this.estimateTemplateId);
  }

  // APIから値の取得、表示
  async initEstimateTemplate(estimateTemplateId: string) {
    // テンプレート詳細の現在の値を更新する
    this.estimateTemplate = await getEstimateTemplate(estimateTemplateId);
    // 表示用の estimate を更新する
    if (this.estimateTemplate) {
      this.useTemplate(this.estimateTemplate);
    }
  }

  setCategoryDiscountIds() {
    this.estimate.categoryDiscountIds = this.categoryDiscountIds;
  }

  /**
   * テンプレートを使う
   */
  useTemplate(template: EstimateTemplate): void {
    const items = template.items.map(templateItemToItem);
    this.estimate.items = []; // TODO: リロードのたびに増えてしまうのでリセットしている > 解決したら不要?
    items.forEach(item => {
      this.estimate.items.push(item);
    });
    this.calculateTotal(); // リスト下部の利益率と発注率を計算して表示
  }

  // 一覧画面(親)に移動
  goListPage() {
    this.$router.push({ path: "/admin/estimate-template" });
  }

  // 見積項目: プルダウンセット
  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      {
        id: "",
        name: "",
        important: false,
        expense_category_invoice_flg: false
      },
      ...(await getExpenseCategories())
    ];
  }

  // 見積項目: 行操作
  private editing = false;

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    const grandchildren = e.draggedContext.element.items.reduce(
      (total, item) => total + item.items.length,
      0
    );
    return !(
      (from === "parents" && to === "grandchildren" && children > 0) ||
      (from === "children" && to === "grandchildren" && children > 0) ||
      (from === "parents" && to === "children" && grandchildren > 0)
    );
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculateTotal();
  }

  async addNewItems(items: number) {
    for (let i = 0; i < items; i++) {
      await service.addNewItem(this.estimate);
    }
    this.reloadCheckboxOfEstimateRow();
  }

  async addNewItemAfter(itemId: string) {
    await service.addNewItemAfter(this.estimate, itemId);
    this.reloadCheckboxOfEstimateRow();
  }

  async removeItem(itemId: string) {
    this.estimate = await service.removeItem(this.estimate, itemId);
    this.estimateRowSelected.delete(itemId);
    this.reloadCheckboxOfEstimateRow();
  }

  async removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.estimate = await service.removeAllItems(this.estimate);
    this.estimateRowSelected.clear();
    this.reloadCheckboxOfEstimateRow();
  }

  // 合計額計算
  async calculateTotal() {
    this.estimate = await service.calculateTotal(this.estimate);
    this.reloadCheckboxOfEstimateRow();
  }

  // 発注額計算

  async calculateInvoice(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("発注額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }
    this.estimate = await service.calculateInvoice(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.estimatedToOrderNumberRound,
      this.estimatedToOrderTypeRound
    );
  }

  // 見積額計算
  async calculateFromProfitRate(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("見積額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }

    // TODO: asしなくても通るように型定義したい
    this.estimate = estimateRoundedFromProfitRate(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.orderToEstimatedNumberRound,
      this.orderToEstimatedTypeRound
    ) as Estimate;
    this.estimate = await service.calculateTotal(this.estimate);
  }

  // APIへ値の保存
  async saveTemplate() {
    // 動作: 保存して一覧に戻る
    this.status = "progressing";
    if (this.estimateTemplate) {
      await this.$store
        .dispatch("estimateTemplate/save", {
          id: this.estimateTemplate.id,
          title: this.estimateTemplate.title,
          items: this.estimate.items,
          documentId: this.$route.query.documentId
        })
        .then(() => {
          alert("保存しました。");
          this.goListPage();
        })
        .catch((e: Error) => {
          alert(e.message);
        })
        .finally(() => {
          this.status = "";
        });
    }
  }

  toggleNoteColumn(isChecked: boolean) {
    this.isShowNoteColumn = isChecked;
    this.header = isChecked ? this.headerDefault : this.headerWithoutNoteColumn;
    this.styleGridColumn = this.getWidthsString(this.header);
  }

  addIdsFromLowestItems(items: EstimateItemModel[]) {
    items.forEach(item => {
      if (item.items.length > 0) {
        this.addIdsFromLowestItems(item.items);
      } else {
        this.estimateRowSelected.add(item.id.toString());
      }
    });
  }

  checkAllEstimateRow(isChecked: boolean) {
    this.estimateRowSelected.clear();

    if (isChecked) {
      this.addIdsFromLowestItems(this.estimate.items);
      this.addIdsFromLowestItems(
        this.estimate.children.flatMap(child => child.items)
      );
    }

    this.reloadCheckboxOfEstimateRow();
  }

  deleteRowIdInvalid(item: EstimateItemModel) {
    if (
      item.items.length > 0 ||
      this.categoryDiscountIds.includes(item.expenseCategoryId)
    ) {
      if (this.estimateRowSelected.has(item.id.toString())) {
        this.estimateRowSelected.delete(item.id.toString());
      }
      item.items.forEach(it => this.deleteRowIdInvalid(it));
    }
  }

  deleteIdInvalidInEstimateRowSelected() {
    this.estimate.items.forEach(item => this.deleteRowIdInvalid(item));
    this.estimate.children.forEach(child =>
      child.items.forEach(item => this.deleteRowIdInvalid(item))
    );
  }

  reloadCheckboxOfEstimateRow() {
    // delete the parent row id if there is a child row id in the set
    this.deleteIdInvalidInEstimateRowSelected();

    // Recreate the set to trigger reactivity
    this.estimateRowSelected = new Set(Array.from(this.estimateRowSelected));

    // reload checkbox all row
    this.reloadCheckboxAll();
  }

  @Watch("estimate", { immediate: true })
  loadExpenseCategory() {
    this.expenseCategoriesSelected = calculateExpenseCategory(
      this.estimate,
      this.expenseCategoryOptions,
      this.categoryDiscountIds
    );
  }

  reloadCheckboxAll() {
    let numberItems = this.countTotalItems(this.estimate.items);
    this.estimate.children.forEach(child => {
      numberItems += this.countTotalItems(child.items);
    });
    if (numberItems === 0) {
      this.isCheckAllEstimateRow = false;
      return;
    }
    let countItemsSelected = service.getIdsSelected(
      this.estimate,
      this.estimateRowSelected
    ).size;
    this.isCheckAllEstimateRow = countItemsSelected === numberItems;
  }

  countTotalItems(items: EstimateItemModel[]): number {
    let result = 0;
    result += items.filter(
      item => !this.categoryDiscountIds.includes(item.expenseCategoryId)
    ).length;
    items.forEach(item => {
      if (item.items.length > 0) {
        result += this.countTotalItems(item.items);
      }
    });
    return result;
  }

  getWidthsString(header: HeaderItem[]): string {
    const widths: string[] = [];

    header.forEach(item => {
      if (item.subs.length === 0 && item.width) {
        widths.push(item.width);
      } else {
        item.subs.forEach(sub => {
          widths.push(sub.width);
        });
      }
    });

    return widths.join(" ");
  }

  get lossTotal(): string {
    let totalPrice: number = 0;
    let loss: number = 0;
    this.estimate.items.forEach(item => {
      totalPrice += item.totalPrice;
      loss += item.loss;
    });

    this.estimate.children.forEach(child => {
      child.items.forEach(item => {
        totalPrice += item.totalPrice;
        loss += item.loss;
      });
    });

    return (totalPrice - loss).toLocaleString();
  }

  get templateProfitRate() {
    return {
      profitRate: new Decimal(this.estimate.profitRate).div(100).toNumber(),
      lossRate: new Decimal(this.estimate.lossRate).div(100).toNumber()
    };
  }

  isNegative(value: number): boolean {
    return value < 0;
  }

  upLevel(
    oldParent: EstimateItemModel | null,
    newParent: Estimate | null,
    item: EstimateItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.indexOf(oldParent) + 1, 0, item);
    this.calculateTotal();
  }

  downLevel(
    oldParent: EstimateItemModel | null,
    newParent: Estimate | null,
    item: EstimateItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.length, 0, item);
    this.calculateTotal();
  }
}

function templateItemToItem(item: EstimateTemplateItem): EstimateItemModel {
  return {
    ...item,
    rowUuid: "",
    totalPrice: 0,
    loss: 0,
    items: (item.items || []).map(n => templateItemToItem(n)),
    purchased: false,
    purchasedRow: false,
    vendorName: ""
  };
}
